<template>
	
<div class="card-foot" :class="{'is-borderless': borderless}">

	<slot></slot>

</div>

</template>

<script>

export default {

	props: ['borderless']

}

</script>

<style scoped>

.card-foot {
	flex-shrink: 0;
	display: grid;

	/* Key change */
	grid-template-columns: repeat(auto-fit, minmax(64px, 1fr));

	align-items: center;
	justify-items: center;   /* center items within their cells */
	justify-content: center; /* center the grid itself when not full-width */

	border: 1px solid #ddd;
	padding: 10px;
	gap: 10px;

	border-radius: 0px 0px 4px 4px;
	background-color: #fff;
	border-width: 1px;
}

.is-mobile .card-foot {
	gap: 5px;
	padding: 10px 5px;
}

.card-foot.is-borderless {
	border-top: 0px;
}

</style>
